import { candidateRequests } from "api/candidateApi";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { CampaignTypes } from "utils/constants";

const CoursesCampaignCandidates = ({ handleParamChange }) => {
  return (
    <>
      <ReferenceInput
        label="Кампания"
        source="campaignId"
        reference={candidateRequests.getCampaignsSelect()}
        filter={{ type: CampaignTypes.PreparatoryCourses }}
      >
        <SelectInput
          validate={required()}
          label="Кампания"
          optionText="nameBg"
          onChange={e => handleParamChange("campaignId", e.target.value)}
        />
      </ReferenceInput>
    </>
  );
};

export default CoursesCampaignCandidates;
